var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedevlopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14094_20387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 25V23H27.9C27.8 22.4 27.5 21.8 27.2 21.2L28.7 19.7L27.3 18.3L25.8 19.8C25.3 19.5 24.7 19.2 24 19.1V17H22V19.1C21.4 19.2 20.8 19.5 20.2 19.8L18.7 18.3L17.3 19.7L18.8 21.2C18.5 21.7 18.2 22.3 18.1 23H16V25H18.1C18.2 25.6 18.5 26.2 18.8 26.8L17.3 28.3L18.7 29.7L20.2 28.2C20.7 28.5 21.3 28.8 22 28.9V31H24V28.9C24.6 28.8 25.2 28.5 25.8 28.2L27.3 29.7L28.7 28.3L27.2 26.8C27.5 26.3 27.8 25.7 27.9 25H30ZM23 27C21.3 27 20 25.7 20 24C20 22.3 21.3 21 23 21C24.7 21 26 22.3 26 24C26 25.7 24.7 27 23 27ZM21.4854 7.126L12.4858 2.126C12.1831 1.958 11.8169 1.958 11.5141 2.126L2.5142 7.126C2.1968 7.3023 2 7.6367 2 8V18C2 18.3633 2.1968 18.6982 2.5142 18.874L11.5142 23.874C11.6656 23.958 11.833 24 12 24C12.1753 24 12.3506 23.9541 12.5073 23.8623C12.8125 23.6826 13 23.3545 13 23V13.5884L20 9.6993V14H22V8C22 7.6367 21.8027 7.3022 21.4854 7.126ZM12 4.144L18.9411 8.0001L12 11.8559L5.0591 7.9999L12 4.144ZM4 17.4111V9.6994L11 13.5883V21.3007L4 17.4111Z",
    fill: "#EEA600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14094_20387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedevlopment);
export default __webpack_public_path__ + "static/media/Feature devlopment.0104d9c92754332a6ad230fe6a7481a5.svg";
export { ForwardRef as ReactComponent };